import { render, staticRenderFns } from "./ModalLabels.vue?vue&type=template&id=bd939382"
import script from "./ModalLabels.vue?vue&type=script&lang=js"
export * from "./ModalLabels.vue?vue&type=script&lang=js"
import style0 from "./ModalLabels.vue?vue&type=style&index=0&id=bd939382&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports